import { ConfigProvider } from "antd";
import { FC, ReactNode } from "react";
import { colors, text } from "./baseConfigs";
import { styledComponents } from "./componentConfigs";

interface Props {
  children: ReactNode;
}

const theme = {
  token: {
    ...colors,
    ...text
  },
  components: {
    ...styledComponents
  }
};

const ThemeProvider: FC<Props> = ({ children }) => {
  return <ConfigProvider theme={theme}>{children}</ConfigProvider>;
};

export default ThemeProvider;
